import { render, staticRenderFns } from "./Consoles.vue?vue&type=template&id=97438c94"
import script from "./Consoles.vue?vue&type=script&lang=ts"
export * from "./Consoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports